import React from "react";

const TypingIndicator: React.FC = () => {
  return (
    <div className="flex justify-start mb-4">
      <div className="bg-gray-200 text-gray-800 rounded-lg rounded-bl-none px-4 py-2 max-w-[120px]">
        <div className="flex items-center space-x-1">
          <span className="w-2 h-2 bg-gray-500 rounded-full animate-[bounceY_1.2s_infinite] [animation-delay:-0.3s]"></span>
          <span className="w-2 h-2 bg-gray-500 rounded-full animate-[bounceY_1.2s_infinite] [animation-delay:-0.15s]"></span>
          <span className="w-2 h-2 bg-gray-500 rounded-full animate-[bounceY_1.2s_infinite]"></span>
        </div>
      </div>
    </div>
  );
};

export default TypingIndicator;
